import { apiCall } from "../helpers/api";

export const hunts =
    (params = {}) =>
    (dispatch) => {
        params.path = params.path || "jobs";
        return dispatch(apiCall(params));
    };
